import { render } from "./StatusView.vue?vue&type=template&id=22d38fa6"
import script from "./StatusView.vue?vue&type=script&lang=js"
export * from "./StatusView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__